import React from 'react'

import { Block } from 'elements/layout/Block'
import { BorderedDiv } from 'elements/layout/BorderedDiv'
import { Cell } from 'elements/layout/Cell'
import { Div } from 'elements/layout/Div'
import { PreloadDiv } from 'elements/layout/PreloadDiv'
import { RoundDiv } from 'elements/layout/RoundDiv'
import { Row } from 'elements/layout/Row'
import { StretchCell } from 'elements/layout/StretchCell'

export const PreloadPublicationBlock: TFC = () => (
  <Block square noPrint>
    {/* header */}
    <Div p={{ xs: '1em', sm: '1em 1em' }} m={{ xs: '0', md: '0 0 0 -46px', lg: '0', xl: '0 0 0 -46px' }}>
      <Row align="middleLeft" gutter="10px" nowrap>
        <Cell>
          <PreloadDiv as={RoundDiv} size="60px" />
        </Cell>
        <StretchCell flex="1">
          <PreloadDiv h="40px" />
          <PreloadDiv w={{ xs: '200px', sm: '300px' }} h="1em" />
        </StretchCell>
      </Row>
    </Div>
    {/* title */}
    <Div p="0 1em" m="0 0 1em">
      <PreloadDiv w="80%" h="36px" />
    </Div>
    {/* image */}
    <PreloadDiv h="300px" />
    {/* button */}
    <Div p="1em">
      <PreloadDiv m="auto" as={BorderedDiv} h="40px" w="120px" borderRadius="25px" />
    </Div>
    <Row p="1em" align="middleLeft">
      <Cell w="100px">
        <PreloadDiv h="25px" m="12px" />
      </Cell>
      <Cell w="100px">
        <PreloadDiv h="25px" m="12px" />
      </Cell>
    </Row>
  </Block>
)
